import ApiService from '@/services/ApiService';
import { defineStore } from 'pinia';
import { useModalStore } from './ModalStore';

export const usePipeStore = defineStore('pipe', {
  state () {
    return {
      modalError: false,
      modalPipeSuccess: false,
      modalPipeSuccessObj: null,
      errorList: [],
      // todo: this pipe data would come from the server
      pipes: null,
      userPipes: [],
      pipeMode: 'default',
      editedPipe:  {
        pipeId: 5,
        description: 'pipe e',
        class: 'class',
        roughness: 22.2,
        maxPressure: 252.2,
        enable: true,
        code: 'PE',
        usage: 'L',
        nps: .2521,
        id: .1321
      },
      addPipe: {
        pipeId: 0,
        desc: null,
        class: null,
        roughness: '',
        max_pressure_Pa: 0,
        code: 'PE',
        usage: 'L',
        nominal_dia_m: 0,
        internal_dia_m: 0,
        small_Desc: null,
        deleted: false
      },
      pipeData: [
        { label: 'Description', placeholder: 'Pipe Description', type: 'input', field: 'text', value: 'desc' },
        { label: 'Class', placeholder: 'Pipe Class', type: 'input', field: 'number', value: 'class' },
        { label: 'Roughness', placeholder: 'Pipe Roughness', type: 'input', field: 'number', value: 'roughness' },
        { label: 'Max Pressure', placeholder: 'Pipe Max Pressure', type: 'input', field: 'number', value: 'max_pressure_Pa' },
        { label: 'Code', options: ['PE','PVC','ALUM'], type: 'selector', field: 'select', value: 'code' },
        { label: 'Usage', options: ['L','LE','LS'], type: 'selector', field: 'select', value: 'usage' },
        { label: 'NominialDiameter', type: 'numeric', field: 'number', value: 'nominal_dia_m' },
        { label: 'InternalDiameter', type: 'numeric', field: 'number', value: 'internal_dia_m' }
      ],
      allowPipeEdit: false,
      pipeModalVisible: false,
      editedPipeData: null,
      uneditedPipeData: null,
      pipeOptionTarget: null,
    };
  },
  getters: {
    getPipes () {
      return this.pipes;
    },
    getPipeMode () {
      return this.pipeMode;
    },
    getPipeOptionTarget () {
      return this.pipeOptionTarget;
    },
    getEditedPipe () {
      return this.editedPipe;
    },
    getAllowPipeEdit () {
      return this.allowPipeEdit;
    },
    getPipeModalVisible () {
      return this.pipeModalVisible;
    },
    getModalPipeSuccess () {
      return this.modalPipeSuccess;
    }
  },
  actions: {
    setPipeMode (value) {
      this.pipeMode = value;
    },
    setPipeOptionTarget (value) {
      this.pipeOptionTarget = value;
    },
    setEditedPipeValue (type, value) {
      this.editedPipe[type] = value;
    },
    getPipesData () {
      ApiService.getPipes()
        .then((response) => {
          let pipes = response.data;
          pipes.forEach((element) => {
            element.enable = true;
          });
          this.pipes = pipes;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPipeData (type) {
      return this.pipeData.filter((data) => data.type === type);
    },
    setEditedPipe (pipe) {
      this.editedPipe = pipe;
    },
    getPipeById (id) {
      return this.pipes.find((data) => data.id === id);
    },
    setAllowPipeEdit (bool, mode) {
      this.allowPipeEdit = bool;
      if (bool) {
        if (mode === 'edit') {
          this.editedPipeData = JSON.parse(JSON.stringify(this.editedPipe));
        }
        if (mode === 'add') {
          this.editedPipeData = JSON.parse(JSON.stringify(this.addPipe));
        }
        // storing unedited pipe in case they hit cancel
        this.uneditedPipeData = JSON.parse(JSON.stringify(this.editedPipe));
        this.editedPipe = this.editedPipeData;
      }
    },
    setPipeModalVisible (bool) {
      this.pipeModalVisible = bool;
    },
    resetEditPipe () {
      this.editedPipe = JSON.parse(JSON.stringify(this.uneditedPipeData));
      this.allowPipeEdit = false;
    },
    updateEditPipe () {
      if (this.pipeMode === 'add') {
        this.errorList = [];
        if (this.editedPipeData.roughness.length === 0) {
          this.errorList.push({
            key: 'roughness',
            name: 'Roughness',
            error: 'missing_value'
          });
        }
        if (this.editedPipeData.desc === null) {
          this.errorList.push({
            key: 'description',
            name: 'Description',
            error: 'missing_value'
          });
        }
        if (this.editedPipeData.internal_dia_m <= 0) {
          this.errorList.push({
            key: 'internal_dia_m',
            name: 'ø ID',
            error: 'greater_then_zero'
          });
        } 
        if (this.editedPipeData.nominal_dia_m <= 0) {
          this.errorList.push({
            key: 'internal_dia_m',
            name: 'ø NPS',
            error: 'greater_then_zero'
          });
        }
        if (this.errorList.length > 0) {
          this.modalError = true;
        } else {
          if (this.editedPipeData.class === null) {
            this.editedPipeData.class = 0;
          }
          this.allowPipeEdit = false;
          delete Object.assign(this.editedPipeData, { 'id': this.editedPipeData['pipeId'] })['pipeId'];
          this.postPipe(this.editedPipeData);
        }
      } else if (this.pipeMode === 'edit') {
        this.errorList = [];
        if (this.editedPipeData.roughness.length === 0) {
          this.errorList.push({
            key: 'roughness',
            name: 'Roughness',
            error: 'missing_value'
          });
        }
        if (this.editedPipeData.desc === null || this.editedPipeData.desc.length === 0) {
          this.errorList.push({
            key: 'description',
            name: 'Description',
            error: 'missing_value'
          });
        }
        if (this.editedPipeData.internal_dia_m <= 0) {
          this.errorList.push({
            key: 'internal_dia_m',
            name: 'ø ID',
            error: 'greater_then_zero'
          });
        } 
        if (this.editedPipeData.nominal_dia_m <= 0) {
          this.errorList.push({
            key: 'internal_dia_m',
            name: 'ø NPS',
            error: 'greater_then_zero'
          });
        }
        if (this.errorList.length > 0) {
          this.modalError = true;
        } else {
          this.allowPipeEdit = false;
          let cnt = this.userPipes.findIndex( (pipe) => pipe.id === this.editedPipeData.pipeId);
          this.userPipes.splice(cnt, 1, this.editedPipeData);
          this.postPipe(this.editedPipeData);
        }
      }
    },
    async postPipe (pipe) {
      return await ApiService.postPipe(pipe)
        .then((response) => {
          this.getPipesData();
          if (this.pipeMode === 'add') { 
            this.editedPipe = this.uneditedPipeData; 
            this.modalPipeSuccess = true;
            this.modalPipeSuccessObj = response.data;
          } 
          this.pipeMode = 'default';
          this.allowPipeEdit = false;
        });
    },
    async deletePipe (pipeId) {
      return await ApiService.removePipe(pipeId)
        .then(() => {
          this.getPipesData();
          useModalStore().showModal('pipe');
        });
    },
  }
});